import { ImageWithFallback } from '@/components/ui/ImageWithFallback';
import { BrandDto } from '@shelflix/trpc/routes/brand/list/useCase';
import { Badge } from '@shelflix/ui-web/components/ui/badge';
import { Card } from '@shelflix/ui-web/components/ui/card';
import { useNavigate } from 'react-router-dom';

export default function BrandCard(brand: BrandDto & React.HTMLAttributes<typeof Card>) {
  const navigate = useNavigate();

  return (
    <Card
      className="relative flex aspect-video cursor-pointer flex-row items-center rounded-sm p-0"
      onClick={() => {
        navigate(`${brand.uuid}`, {
          state: {
            brandName: brand.name,
          },
        });
      }}
    >
      <div className="z-0000 absolute top-0 right-2 rounded-xl">
        <Badge
          className={`h-4 rounded-sm px-3 py-1 text-xs font-semibold ${
            brand.active === true
              ? 'bg-[var(--active)] text-[var(--active-dark)]'
              : 'bg-[var(--inactive)] text-[var(--inactive-dark)]'
          }`}
        >
          {brand.active === true ? 'Ativa' : 'Inativa'}
        </Badge>
      </div>

      <ImageWithFallback
        src={brand.logoUrl}
        alt={brand.name + ' logo'}
        objectFit="cover"
        containerClassName="h-full w-full rounded-sm"
        className="bg-foreground py-0"
      />
    </Card>
  );
}
